// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__njkQq","heading--sub":"Heading_heading--sub__3JHrc"};